/**
 * The base URL for API requests, configured via VITE_API_URL.
 * This should be the full URL to the API (e.g., "http://localhost:3001").
 */
export const apiBaseUrl = import.meta.env.VITE_API_URL ?? "";

/**
 * The base URL for realtime server requests, configured via VITE_REALTIME_URL.
 * This should be the full URL to the realtime service (e.g., "http://localhost:3002").
 */
export const realtimeBaseUrl = import.meta.env.VITE_REALTIME_URL ?? "";

/**
 * Build a URL to the API using the configured VITE_API_URL.
 */
export const buildApiUrl = (path = ""): string => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${apiBaseUrl}${normalized}`;
};

/**
 * Build a URL to the realtime server using the configured VITE_REALTIME_URL.
 */
export const buildRealtimeUrl = (path = ""): string => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${realtimeBaseUrl}${normalized}`;
};

export const peerServerUrl = realtimeBaseUrl;
export const webrtcIceServersEndpointUrl = buildRealtimeUrl("/ice-servers");

export const createDonationCheckoutUrl = buildApiUrl(
  "/products/donation-checkout"
);

export const newsletterSubscribeUrl = buildApiUrl("/newsletter/subscribe");
